export const headerSession = {
  Date: 'transactionDate',
  'Start Time': 'time',
  'Charger ID': 'iotHubDeviceId',
  Service: 'entryType',
  Time: 'totalTime',
  'Avg kW': 'avgkW',
  kWhs: 'totalkWh',
  'Rate Type': 'rateType',
  Rate: 'rate',
  Amt: 'totalCost',
};

export const headerFees = {
  Date: 'date',
  'Fee Type': 'feeType',
  'Charger ID': 'iotHubDeviceId',
  Ports: 'ports',
  Rate: 'rate',
  Amt: 'amount',
};

export const headerIncome = {
  'Post Date': 'postDate',
  'Bank Name': 'bankName',
  'Bank Routing No': 'bankRoutingNo',
  'Account No': 'accountNo',
  'Trans ID': 'transId',
  Amt: 'amt',
};
